import api from './api';

const fmt = (n) => {
  if (n === null || n === undefined) return '₹0';
  if (n >= 100000) return `₹${(n / 100000).toFixed(1)}L`;
  if (n >= 1000)   return `₹${(n / 1000).toFixed(1)}K`;
  return `₹${n.toLocaleString('en-IN')}`;
};

const fmtRaw = (n) =>
  n !== null && n !== undefined ? `₹${Number(n).toLocaleString('en-IN')}` : '₹0';

const financeService = {

  /* ── Overview stats ─────────────────────────────────── */
  getOverview: async () => {
    const r = await api.get('/finance/overview');
    const d = r.data;
    return {
      totalCollection:   d.totalCollection   || 0,
      pendingPayments:   d.pendingPayments    || 0,
      pendingCount:      d.pendingCount       || 0,
      totalPaycardBalance: d.totalPaycardBalance || 0,
      overdueAmount:     d.overdueAmount      || 0,
      overdueCount:      d.overdueCount       || 0,
      // formatted for UI cards
      totalCollectionFmt:     fmt(d.totalCollection),
      pendingPaymentsFmt:     fmt(d.pendingPayments),
      totalPaycardBalanceFmt: fmt(d.totalPaycardBalance),
      overdueAmountFmt:       fmt(d.overdueAmount),
    };
  },

  /* ── Fee list ────────────────────────────────────────── */
  getFeeList: async (status, search) => {
    const params = {};
    if (status && status !== 'all') params.status = status;
    if (search) params.search = search;
    const r = await api.get('/finance/fees', { params });
    return (r.data || []).map(item => ({
      ...item,
      totalFmt:   fmtRaw(item.totalFees),
      paidFmt:    fmtRaw(item.paidAmount),
      balanceFmt: fmtRaw(item.balance),
    }));
  },

  /* ── Student fee detail ─────────────────────────────── */
  getStudentFeeDetail: async (admissionId) => {
    const r = await api.get(`/finance/fees/${admissionId}`);
    const d = r.data;
    return {
      ...d,
      totalFmt:   fmtRaw(d.totalFees),
      paidFmt:    fmtRaw(d.paidAmount),
      balanceFmt: fmtRaw(d.balance),
    };
  },

  /* ── Collect fee payment ─────────────────────────────── */
  collectPayment: async (payload) => {
    const r = await api.post('/finance/fees/collect', payload);
    return r.data;
  },

  /* ── Outstanding dues ────────────────────────────────── */
  getOutstanding: async () => {
    const r = await api.get('/finance/outstanding');
    return (r.data || []).map(item => ({
      ...item,
      totalFmt:   fmtRaw(item.totalFees),
      paidFmt:    fmtRaw(item.paidAmount),
      balanceFmt: fmtRaw(item.balance),
    }));
  },

  /* ── PayCard list ────────────────────────────────────── */
  getPayCardList: async (search) => {
    const params = {};
    if (search) params.search = search;
    const r = await api.get('/finance/paycards', { params });
    return (r.data || []).map(item => ({
      ...item,
      balanceFmt: fmtRaw(item.balance),
      topupFmt:   fmtRaw(item.totalTopup),
      spentFmt:   fmtRaw(item.totalSpent),
    }));
  },

  /* ── PayCard detail ──────────────────────────────────── */
  getPayCardDetail: async (admissionId) => {
    const r = await api.get(`/finance/paycards/${admissionId}`);
    const d = r.data;
    return {
      ...d,
      balanceFmt: fmtRaw(d.balance),
      topupFmt:   fmtRaw(d.totalTopup),
      spentFmt:   fmtRaw(d.totalSpent),
    };
  },

  /* ── Top-up pay card ─────────────────────────────────── */
  topup: async (admissionId, amount, paymentMode, referenceId) => {
    const r = await api.post('/finance/paycards/topup', {
      admissionId, amount, paymentMode, referenceId,
    });
    return r.data;
  },

  /* ── Toggle card block ───────────────────────────────── */
  toggleBlock: async (admissionId) => {
    const r = await api.patch(`/finance/paycards/${admissionId}/toggle-block`);
    return r.data;
  },

  /* ── All transactions (with filter) ─────────────────── */
  getTransactions: async (filterType, date, month) => {
    const params = { filterType };
    if (date)  params.date  = date;
    if (month) params.month = month;
    const r = await api.get('/finance/transactions', { params });
    return r.data || [];
  },
};

export default financeService;